import React, { useState } from 'react';
import { ConfigProvider, theme, Menu, Table, Button, Modal, Input, Select, Avatar, Dropdown } from 'antd';
import {
    Settings, Box, MapPin, Tag, Plus, Trash2, Edit, MoreHorizontal, CheckCircle2
} from 'lucide-react';
import Layout from '../../Layout';
import { Link } from 'react-router-dom';

const THEME_COLOR = '#3e91ab';

// ============================================================================
// COMPONENT 1: TAB LOẠI TÀI SẢN
// ============================================================================
const AssetTypeTab = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const data = [
        { key: '1', name: 'Arm Màn hình', prop: 'Tài sản cố định hữu hình', alloc: 'Cấp phát có thu hồi', date: '14/11/2023', creator: 'A' },
        { key: '2', name: 'Apple Pencil', prop: 'Tài sản cố định hữu hình', alloc: 'Cấp phát có thu hồi', date: '14/11/2023', creator: 'A' },
        { key: '3', name: 'Bộ phím chuột', prop: 'Tài sản cố định hữu hình', alloc: 'Cấp phát có thu hồi', date: '14/11/2023', creator: 'A' },
        { key: '4', name: 'Bàn phím dây', prop: 'Tài sản cố định hữu hình', alloc: 'Cấp phát có thu hồi', date: '14/11/2023', creator: 'A' },
        { key: '5', name: 'Chuột dây', prop: 'Tài sản cố định hữu hình', alloc: 'Cấp phát có thu hồi', date: '14/11/2023', creator: 'A' },
    ];

    const columns = [
        {
            title: selectedRowKeys.length > 0 ? (
                <div
                    className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 cursor-pointer transition-colors whitespace-nowrap"
                    onClick={() => Modal.confirm({
                        title: 'Xác nhận',
                        content: 'Bạn có chắc chắn muốn xóa bản ghi này?',
                        okText: 'ĐỒNG Ý',
                        cancelText: 'HỦY BỎ',
                        okButtonProps: { danger: true }
                    })}
                >
                    <Trash2 size={16} /> <span className="font-normal text-[13px]">Xóa</span>
                </div>
            ) : <span className="whitespace-nowrap">Loại tài sản</span>,
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-gray-800 dark:text-gray-200 font-medium whitespace-nowrap">{text}</span>
        },
        { title: 'Thuộc tính tài sản', dataIndex: 'prop', key: 'prop', render: (text) => <span className="text-gray-600 dark:text-gray-300 whitespace-nowrap">{text}</span> },
        { title: 'Cấp phát', dataIndex: 'alloc', key: 'alloc', render: (text) => <span className="text-gray-600 dark:text-gray-300 whitespace-nowrap">{text}</span> },
        { title: 'Ngày tạo', dataIndex: 'date', key: 'date', render: (text) => <span className="text-gray-600 dark:text-gray-300 whitespace-nowrap">{text}</span> },
        {
            title: 'Người tạo',
            dataIndex: 'creator',
            key: 'creator',
            render: (text) => <Avatar size={24} className="bg-[#3e91ab] text-[11px] font-semibold text-white">A</Avatar>
        },
        {
            title: '',
            key: 'action',
            width: 50,
            fixed: 'right', // Ghim cột thao tác ở cuối khi cuộn trên mobile
            render: () => (
                <Dropdown
                    menu={{
                        items: [
                            { key: 'edit', icon: <Edit size={14} />, label: 'Sửa' },
                            { key: 'delete', icon: <Trash2 size={14} />, label: 'Xóa', danger: true },
                        ]
                    }}
                    trigger={['click']}
                    placement="bottomRight"
                >
                    {/* Trên Mobile không có hover, ép opacity-100. Trên PC ẩn chờ hover */}
                    <div className="w-8 h-8 rounded hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-center cursor-pointer text-gray-500 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                        <MoreHorizontal size={16} />
                    </div>
                </Dropdown>
            )
        }
    ];

    return (
        <div className="flex flex-col bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 min-h-[calc(100vh-180px)] md:min-h-[500px]">
            <div className="flex justify-between items-center px-4 md:px-6 py-3 md:py-4 border-b border-gray-200 dark:border-gray-700">
                <div className="flex gap-6">
                    <span className="text-[#3e91ab] font-medium border-b-2 border-[#3e91ab] pb-[14px] md:pb-4 -mb-[13px] md:-mb-[17px]">Loại tài sản</span>
                </div>
                <div
                    className="flex items-center gap-1.5 text-gray-500 hover:text-[#3e91ab] cursor-pointer text-[13px] md:text-[13.5px] font-medium transition-colors md:bg-transparent px-3 py-1.5 md:p-0 rounded-md border md:border-0 border-gray-200 dark:border-gray-600"
                    onClick={() => setIsCreateModalOpen(true)}
                >
                    <Plus size={16} /> Tạo mới
                </div>
            </div>

            <div className="p-0 md:p-4 flex-1 w-full overflow-hidden">
                <Table
                    rowSelection={{
                        selectedRowKeys,
                        onChange: setSelectedRowKeys,
                    }}
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    rowClassName="group hover:bg-gray-50/50 dark:hover:bg-gray-800/50 transition-colors"
                    size="middle"
                    className="custom-ant-table text-[13px]"
                    scroll={{ x: 800 }} // Kích hoạt vuốt ngang trên Mobile
                />
            </div>

            <div className="px-4 md:px-6 py-3 border-t border-gray-100 dark:border-gray-800 text-gray-400 text-xs">
                Hiển thị 1 - {data.length} / {data.length} bản ghi
            </div>

            <Modal
                title={<span className="font-bold text-gray-800 dark:text-gray-100 text-base">Tạo mới loại tài sản</span>}
                open={isCreateModalOpen}
                onCancel={() => setIsCreateModalOpen(false)}
                centered // Căn giữa màn hình Mobile
                footer={[
                    <Button key="back" onClick={() => setIsCreateModalOpen(false)}>HỦY BỎ</Button>,
                    <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>,
                ]}
            >
                <div className="flex flex-col gap-4 py-4">
                    <div>
                        <label className="text-[13px] text-gray-500 dark:text-gray-400 mb-1.5 block">Tên loại tài sản <span className="text-red-500">*</span></label>
                        <Input size="large" className="dark:bg-gray-800 dark:border-gray-600" placeholder="Nhập tên..." />
                    </div>
                    <div>
                        <label className="text-[13px] text-gray-500 dark:text-gray-400 mb-1.5 block">Thuộc tính tài sản</label>
                        <Select size="large" className="w-full" defaultValue="ts_codinh" options={[{ value: 'ts_codinh', label: 'Tài sản cố định hữu hình' }]} />
                    </div>
                    <div>
                        <label className="text-[13px] text-gray-500 dark:text-gray-400 mb-1.5 block">Cấp phát <span className="text-red-500">*</span></label>
                        <Select size="large" className="w-full" defaultValue="cp_thuhoi" options={[{ value: 'cp_thuhoi', label: 'Cấp phát có thu hồi' }]} />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

// ============================================================================
// COMPONENT 2: TAB VỊ TRÍ TÀI SẢN
// ============================================================================
const AssetLocationTab = () => {
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const data = [
        { key: '1', name: 'HCM - Lầu 1', status: 'Hoạt động', date: '14/11/2023', creator: 'A' },
        { key: '2', name: 'HCM - Lầu 2', status: 'Hoạt động', date: '14/11/2023', creator: 'A' },
        { key: '3', name: 'HCM - Lầu 3', status: 'Hoạt động', date: '14/11/2023', creator: 'A' },
    ];

    const columns = [
        { title: 'Vị trí', dataIndex: 'name', key: 'name', render: (text) => <span className="text-gray-800 dark:text-gray-200 font-medium whitespace-nowrap">{text}</span> },
        { title: 'Trạng thái', dataIndex: 'status', key: 'status', render: () => <span className="px-2 py-0.5 bg-green-100 text-green-700 border border-green-200 rounded text-xs whitespace-nowrap">Hoạt động</span> },
        { title: 'Ngày tạo', dataIndex: 'date', key: 'date', render: (text) => <span className="text-gray-600 dark:text-gray-300 whitespace-nowrap">{text}</span> },
        { title: 'Người tạo', dataIndex: 'creator', key: 'creator', render: () => <Avatar size={24} className="bg-[#3e91ab] text-[11px] font-semibold text-white">A</Avatar> },
    ];

    return (
        <div className="flex flex-col bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 min-h-[calc(100vh-180px)] md:min-h-[500px]">
            <div className="flex justify-between items-center px-4 md:px-6 py-3 md:py-4 border-b border-gray-200 dark:border-gray-700">
                <div className="flex gap-6"><span className="text-[#3e91ab] font-medium border-b-2 border-[#3e91ab] pb-[14px] md:pb-4 -mb-[13px] md:-mb-[17px]">Vị trí tài sản</span></div>
                <div
                    className="flex items-center gap-1.5 text-gray-500 hover:text-[#3e91ab] cursor-pointer text-[13px] md:text-[13.5px] font-medium transition-colors md:bg-transparent px-3 py-1.5 md:p-0 rounded-md border md:border-0 border-gray-200 dark:border-gray-600"
                    onClick={() => setIsCreateModalOpen(true)}
                >
                    <Plus size={16} /> Tạo mới
                </div>
            </div>
            <div className="p-0 md:p-4 flex-1 w-full overflow-hidden">
                <Table rowSelection={{}} columns={columns} dataSource={data} pagination={false} size="middle" scroll={{ x: 600 }} />
            </div>

            <Modal
                title={<span className="font-bold text-gray-800 dark:text-gray-100 text-base">Tạo mới vị trí tài sản</span>}
                open={isCreateModalOpen}
                onCancel={() => setIsCreateModalOpen(false)}
                centered
                footer={[
                    <Button key="back" onClick={() => setIsCreateModalOpen(false)}>HỦY BỎ</Button>,
                    <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>,
                ]}
            >
                <div className="flex flex-col gap-4 py-4">
                    <div>
                        <label className="text-[13px] text-gray-500 dark:text-gray-400 mb-1.5 block">Vị trí <span className="text-red-500">*</span></label>
                        <Input size="large" className="dark:bg-gray-800 dark:border-gray-600" placeholder="Nhập vị trí..." />
                    </div>
                    <div>
                        <label className="text-[13px] text-gray-500 dark:text-gray-400 mb-1.5 block">Thuộc nhóm cha</label>
                        <Select size="large" className="w-full" allowClear placeholder="Chọn nhóm cha..." />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

// ============================================================================
// COMPONENT 3: TAB NHÃN TÀI SẢN
// ============================================================================
const AssetTagTab = () => {
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const tags = [
        { id: 1, name: 'ITV', color: '#8b5cf6' },
        { id: 2, name: 'QHKH', color: '#ef4444' },
        { id: 3, name: 'SXH', color: '#22c55e' },
    ];

    const colorPalette = ['#000000', '#ef4444', '#f97316', '#eab308', '#22c55e', '#06b6d4', '#3b82f6', '#8b5cf6', '#d946ef', '#f43f5e'];

    return (
        <div className="flex flex-col bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 min-h-[calc(100vh-180px)] md:min-h-[500px]">
            <div className="flex justify-between items-center px-4 md:px-6 py-3 md:py-4 border-b border-gray-200 dark:border-gray-700">
                <div className="flex gap-6"><span className="text-[#3e91ab] font-medium border-b-2 border-[#3e91ab] pb-[14px] md:pb-4 -mb-[13px] md:-mb-[17px]">Nhãn tài sản</span></div>
                <div
                    className="flex items-center gap-1.5 text-white bg-[#3e91ab] hover:bg-[#357f96] cursor-pointer text-[13px] font-medium transition-colors px-3 py-1.5 rounded-md shadow-sm"
                    onClick={() => setIsCreateModalOpen(true)}
                >
                    <Plus size={16} /> <span className="hidden sm:block">Tạo nhãn</span>
                </div>
            </div>

            <div className="p-4 md:p-6 flex flex-wrap gap-3">
                {tags.map(tag => (
                    <Dropdown key={tag.id} menu={{ items: [{ key: 'edit', label: 'Sửa nhãn' }, { key: 'del', label: 'Xóa nhãn', danger: true }] }} trigger={['click', 'hover']}>
                        <div className="px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-200 dark:border-gray-600 flex items-center gap-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 text-[13px] font-medium text-gray-700 dark:text-gray-200 shadow-sm transition-all">
                            <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full shadow-inner" style={{ backgroundColor: tag.color }}></div>
                            {tag.name}
                        </div>
                    </Dropdown>
                ))}
            </div>

            <Modal
                title={<span className="font-bold text-gray-800 dark:text-gray-100 text-base">Tạo nhãn mới</span>}
                open={isCreateModalOpen}
                onCancel={() => setIsCreateModalOpen(false)}
                centered
                footer={[
                    <Button key="back" onClick={() => setIsCreateModalOpen(false)}>HỦY BỎ</Button>,
                    <Button key="submit" type="primary" style={{ backgroundColor: THEME_COLOR }}>CẬP NHẬT</Button>,
                ]}
            >
                <div className="flex flex-col gap-5 py-4">
                    <div className="border-2 border-[#3e91ab] rounded-lg p-2 bg-blue-50/30 dark:bg-gray-800">
                        <Input bordered={false} placeholder="Điền tên nhãn..." className="text-lg font-medium text-[#3e91ab] dark:text-[#5cb1cb] text-center" />
                    </div>
                    <div>
                        <label className="text-[13px] text-gray-500 dark:text-gray-400 mb-2 block text-center">Chọn màu sắc</label>
                        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
                            {colorPalette.map(color => (
                                <div key={color} className="w-6 h-6 md:w-7 md:h-7 rounded-full cursor-pointer hover:scale-110 hover:shadow-md transition-all shadow-sm" style={{ backgroundColor: color }}></div>
                            ))}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

// ============================================================================
// COMPONENT MAIN: LAYOUT CÀI ĐẶT
// ============================================================================
export default function SettingsDashboard() {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [activeMenuKey, setActiveMenuKey] = useState('loai_tai_san');

    const mobileMenuOptions = [
        {
            label: 'Cài đặt chung',
            options: [
                { value: 'loai_tai_san', label: 'Loại tài sản' },
                { value: 'vi_tri', label: 'Vị trí tài sản' },
                { value: 'nhan', label: 'Nhãn tài sản' },
            ],
        },
        // {
        //     label: 'Cài đặt đối tượng',
        //     options: [
        //         { value: 'tai_san', label: 'Tài sản' },
        //         { value: 'cap_phat', label: 'Cấp phát' },
        //         { value: 'thu_hoi', label: 'Thu hồi' },
        //         { value: 'kiem_ke', label: 'Kiểm kê' },
        //     ],
        // }
    ];

    const menuItems = [
        {
            key: 'grp1',
            icon: <Settings size={18} className="text-gray-500 dark:text-gray-400" />,
            label: <span className="font-bold text-gray-800 dark:text-gray-200">Cài đặt chung</span>,
            type: 'group',
            children: [
                { key: 'loai_tai_san', label: 'Loại tài sản' },
                { key: 'vi_tri', label: 'Vị trí tài sản' },
                { key: 'nhan', label: 'Nhãn tài sản' },
            ],
        },
        // {
        //     key: 'grp2',
        //     icon: <Box size={18} className="text-gray-500 dark:text-gray-400" />,
        //     label: <span className="font-bold text-gray-800 dark:text-gray-200 mt-4 block">Cài đặt đối tượng</span>,
        //     type: 'group',
        //     children: [
        //         { key: 'tai_san', label: 'Tài sản' },
        //         { key: 'cap_phat', label: 'Cấp phát' },
        //         { key: 'thu_hoi', label: 'Thu hồi' },
        //         { key: 'kiem_ke', label: 'Kiểm kê' },
        //     ],
        // }
    ];

    const renderContent = () => {
        switch (activeMenuKey) {
            case 'loai_tai_san': return <AssetTypeTab />;
            case 'vi_tri': return <AssetLocationTab />;
            case 'nhan': return <AssetTagTab />;
            default: return <div className="p-10 text-gray-400 bg-white dark:bg-gray-900 rounded-lg border dark:border-gray-700 flex justify-center shadow-sm">Tính năng đang phát triển...</div>;
        }
    };

    return (
        <Layout>
            <ConfigProvider
                theme={{
                    token: { colorPrimary: THEME_COLOR, borderRadius: 6 },
                    algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                    components: {
                        Menu: {
                            itemSelectedBg: isDarkMode ? '#374151' : '#f3f4f6',
                            itemSelectedColor: isDarkMode ? '#f3f4f6' : '#111827',
                            itemColor: isDarkMode ? '#9ca3af' : '#4b5563',
                        },
                        Table: {
                            headerBg: isDarkMode ? '#1f2937' : '#ffffff',
                            headerColor: isDarkMode ? '#9ca3af' : '#6b7280',
                            cellPaddingBlock: 12,
                            borderColor: isDarkMode ? '#374151' : '#f3f4f6'
                        }
                    }
                }}
            >
                <div className="flex flex-col md:flex-row min-h-[calc(100vh-64px)] bg-[#f3f4f6] dark:bg-gray-900">

                    {/* ======================================= */}
                    {/* MENU ĐIỆN THOẠI (SELECT BẬT XUỐNG) */}
                    {/* ======================================= */}
                    <div className="md:hidden w-full p-4 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-[64px] z-20 shadow-sm">
                        <label className="text-[11px] text-gray-500 dark:text-gray-400 mb-1 block uppercase font-bold tracking-wider">Danh mục cài đặt</label>
                        <Select
                            className="w-full"
                            size="large"
                            value={activeMenuKey}
                            onChange={setActiveMenuKey}
                            options={mobileMenuOptions}
                        />
                    </div>

                    {/* ======================================= */}
                    {/* CỘT TRÁI: SIDEBAR MENU DÀNH CHO PC */}
                    {/* ======================================= */}
                    <div className="hidden md:block w-[240px] bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 shrink-0 z-10">
                        {/* Wrapper dính cứng (Sticky) khi cuộn */}
                        <div className="sticky top-[64px] h-[calc(100vh-64px)] overflow-y-auto no-scrollbar">
                            <Menu
                                mode="inline"
                                selectedKeys={[activeMenuKey]}
                                onClick={(e) => setActiveMenuKey(e.key)}
                                items={menuItems}
                                className="border-r-0 pt-4 custom-settings-menu bg-white dark:bg-gray-800"
                            />
                        </div>
                    </div>

                    {/* ======================================= */}
                    {/* CỘT PHẢI: KHU VỰC NỘI DUNG CONTENT */}
                    {/* ======================================= */}
                    <div className="flex-1 py-3 md:py-0 pl-0 md:pl-6 overflow-x-hidden w-full max-w-full">
                        {renderContent()}
                    </div>

                </div>

                {/* Tinh chỉnh CSS cho Sidebar Menu */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    /* Ẩn dấu kẻ dọc mặc định của Table Antd */
                    .ant-table-thead > tr > th::before {
                        display: none !important; 
                    }

                    /* Ẩn thanh cuộn Scrollbar */
                    .no-scrollbar::-webkit-scrollbar { display: none; }
                    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

                    /* Custom Layout Menu */
                    .custom-settings-menu .ant-menu-item-group-title {
                        color: inherit;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding-left: 16px;
                    }
                    .custom-settings-menu .ant-menu-item {
                        margin-left: 16px !important;
                        width: calc(100% - 32px) !important;
                        border-radius: 6px !important;
                    }
                    .custom-settings-menu .ant-menu-item-selected {
                        font-weight: 500;
                    }
                `}} />
            </ConfigProvider>
        </Layout>
    );
}